module.exports = __webpack_public_path__ + "ad0a480815cec84bd04911f1be097dbc.svg";